/* Composables */
import Vue from 'vue'

/* Components */
import App from './App.vue'
import GlassCard from '@/components/reusable/GlassCard.vue'
import LoadingRing from '@/components/reusable/LoadingRing.vue'
import SupportText from '@/components/reusable/SupportText.vue'

/* Router */
import router from './routes/router'

/* State */
import store from './store/store'

/* Plugins */
import VueMask from 'vue-the-mask'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Emitter from 'tiny-emitter'

/* Style */
import 'nprogress/nprogress.css'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = true

Vue.component('GlassCard', GlassCard)
Vue.component('LoadingRing', LoadingRing)
Vue.component('SupportText', SupportText)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueMask)

new Vue({
  router,
  store,
  render: h => h(App),
  beforeCreate() {
    this.$msalInstance = {}
    this.$emitter = new Emitter()
  },
}).$mount('#app')
